// extracted by mini-css-extract-plugin
export default {"intro":"index_intro_czhOB","close":"index_close_-c7Q-","title":"index_title_3Oqct","content":"index_content_5z96S","content_p":"index_content_p_XRwJE","mask":"index_mask_DQPpH"};